import { render, staticRenderFns } from "./AggregateClosed.vue?vue&type=template&id=82f1948c&scoped=true&"
import script from "./AggregateClosed.vue?vue&type=script&lang=js&"
export * from "./AggregateClosed.vue?vue&type=script&lang=js&"
import style0 from "./AggregateClosed.vue?vue&type=style&index=0&id=82f1948c&prod&lang=css&"
import style1 from "./AggregateClosed.vue?vue&type=style&index=1&id=82f1948c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82f1948c",
  null
  
)

export default component.exports